import React, { useEffect, useState } from "react";
import "./OverviewInt.css";
import InternalBar from "../TopLayout/InternalBar/InternalBar";
import BottomCardGroupInt from "../../BottomCardGroupInt/BottomCardGroupInt";
import { useHistory } from "react-router-dom";
import {cosmosTrackService} from "../../../../cosmosTracking/cosmosTrackService";
import {sale_video_tutor} from "../../../../cosmosTracking/cosmosEvents";


function OverViewInt(props) {
  const { data, swipeActions, scrollNav } = props;
  const history = useHistory();
  const statCard = data?.statCard;
  const bottomCard = data?.bottomCard;
  const campaignOrg = data?.campaignOrg;

  return (
    <>
      <div className="page-content page-content-overview" {...swipeActions}>
        <div className="overview-header">
          <img className="img-1" src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-overview-header-text.png" alt="overviewheadertext"/>
          <img className="img-2" src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-overview-header-sub-text2.png" alt="overviewheadersubtext"/>
          <video
              src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/video-tutor2.mp4"
              controls controlsList="nofullscreen nodownload noplaybackrate" disablePictureInPicture playsInline
              onPlay={()=>cosmosTrackService(sale_video_tutor)}>
          </video>
        </div>
        <div className="overview-task">
            <h2>Complete tasks &<br/>win exciting rewards. </h2>
            <p>Get Chance to win prices <b>Worth<br/>40,000/-</b></p>
            {statCard?.slice(0, 2)?.map((item, index) => {
              if (!item?.isComplete) {
                return (
                    <div className="overview-task-card" key={index}>
                      <h3>
                        {item?.task}
                        <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-oveview-card-forward.png" alt="oveviewcardforward" height={12} />
                      </h3>
                      {item?.statType == 3 ? (
                          <p>{item?.completedText}</p>
                      ) : (
                          <p>
                            {item?.total || 0}
                            {item?.completedText}
                          </p>
                      )}
                      <InternalBar height={12} width={item?.percentage} />
                    </div>
                );
              }
            })}
        </div>

        <div className="overview-bottom-card">
          <h1>3x Growth </h1>
          <p>3x your earnings by our Specialised features & get chance to win amazing gifts.</p>
          <BottomCardGroupInt bottomCard={bottomCard} campaignOrg={campaignOrg}></BottomCardGroupInt>
        </div>
        <div className="overview-bottom-img">
          <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-overview-bottom-img.png" alt="overviewbottomimg"/>
        </div>
        <div className="overview-footer">
          <button className="btn-action"
                  onClick={() => {scrollNav(0);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                    history.replace({ pathname: "/tutor/details/tasks" });}}>
            View All Tasks
          </button>
        </div>
      </div>
    </>
  );
}

export default OverViewInt;
